import React, { createContext, useContext, useState } from 'react'

const ProfilePhotoContext = createContext(null)

export function ProfilePhotoProvider({ children }) {
  const [profilePhotoUrl, setProfilePhotoUrl] = useState(null)

  return (
    <ProfilePhotoContext.Provider value={{ profilePhotoUrl, setProfilePhotoUrl }}>
      {children}
    </ProfilePhotoContext.Provider>
  )
}

export function useProfilePhoto() {
  const ctx = useContext(ProfilePhotoContext)
  return ctx || { profilePhotoUrl: null, setProfilePhotoUrl: () => {} }
}
